// Sidebar rows grouped by what the machine does. typeLabels are the descriptions on each robot.
export const TYPE_CATEGORIES = [
  {
    id: "pallets",
    label: "Forklift",
    typeLabels: ["Autonomous Counterbalance Stacker", "Autonomous Slim Forklift"],
  },
  {
    id: "lift",
    label: "Lift",
    typeLabels: ["Safety Lifting Robot", "Rotary Lifting Robot", "Underdrive AMR"],
  },
  {
    id: "tow",
    label: "Tow",
    typeLabels: ["Tunnel and Tow AMR", "Tow AMR"],
  },
  {
    id: "deck",
    label: "Carry",
    typeLabels: ["Platform AMR", "Mobile Robot Platform", "Autonomous Mobile Robot"],
  },
  {
    id: "wheels",
    label: "Wheel",
    typeLabels: ["Autonomous Wheel System"],
  },
];

export const JOBS = [
  {
    slug: "pallets",
    label: "Move pallets",
    description: "Pallet putaway, pickup, and transport between the floor and the rack.",
  },
  {
    slug: "totes",
    label: "Move totes and small parts",
    description: "Kits, totes, and small parts carried between workstations.",
  },
  {
    slug: "tow",
    label: "Tow carts",
    description: "Carts and dollies towed along a plant route.",
  },
  {
    slug: "rack",
    label: "Lift and move racks",
    description: "Racks and carts lifted from below and moved intact.",
  },
  {
    slug: "deck",
    label: "Carry a load on the deck",
    description: "A load carried on top of the robot deck.",
  },
  {
    slug: "retrofit",
    label: "Drive existing carts",
    description: "Wheels that attach to a cart, rack, or trolley the plant already has.",
  },
];

// Hand-picked comparisons only. Adding a pair here registers its URL.
export const COMPARE_PAIRS = [
  {
    slug: "visionnav-vnp15-vs-visionnav-vnsl14",
    left: "visionnav-vnp15",
    right: "visionnav-vnsl14",
  },
  {
    slug: "kuka-kmp-1500-vs-kuka-kmp-600",
    left: "kuka-kmp-1500",
    right: "kuka-kmp-600",
  },
  {
    slug: "seer-slr-1000-vs-seer-sjv-sw600",
    left: "seer-slr-1000",
    right: "seer-sjv-sw600",
  },
  {
    slug: "bluepath-mouse-tunnel-high-vs-bluepath-mouse-tunnel-low",
    left: "bluepath-mouse-tunnel-high",
    right: "bluepath-mouse-tunnel-low",
  },
  {
    slug: "abb-flexley-tug-t702-vs-bluepath-tugger-medium-4000",
    left: "abb-flexley-tug-t702",
    right: "bluepath-tugger-medium-4000",
  },
];
